import { TimesheetHourInterface } from '../../../interfaces/timesheet.interface';

export class PickTimesheetHour {
    public static readonly type = '[JobsPlacements] Pick a timesheet hour';

    constructor(public timesheetHour: TimesheetHourInterface | null) { }
}
